import { useState } from 'react';
import { Modal, StyleSheet, Text, View } from 'react-native';
import moment from 'moment';
import TextInputWithIcon from '@comps/TextInputWithIcon';
import SpaceH from './SpaceH';
import { User } from '@interfaces/iuser';
import ButtonSalvarLimpar from '@comps/ButtonSalvarLimpar';

interface ModalDateProps {
  visible: boolean;
  onClose: () => void;
  onSave: (user: User) => void;
  user?: User;
}

const ModalDate = ({ visible, onClose, user, onSave }: ModalDateProps) => {
  const [endDate, setEndDate] = useState(
    user?.endFreeAccessDate
      ? moment(user.endFreeAccessDate).format('DD/MM/YYYY')
      : moment().format('DD/MM/YYYY')
  );

  const handleSaveUserEdit = () => {
    if (!user) {
      return;
    }

    const endFreeAccessDate = endDate ? moment(endDate, 'DD/MM/YYYY').valueOf() : null;

    onSave({ ...user, endFreeAccessDate });
  };

  return (
    <Modal transparent visible={visible} onRequestClose={onClose}>
      <View style={styles.modalOverlay}>
        <View style={styles.modalContent}>
          <Text>Liberar acesso gratuito para {user?.nome}</Text>
          <SpaceH />
          <SpaceH />
          <TextInputWithIcon
            value={endDate}
            handle={setEndDate}
            placeholder="Gratuito até (DD/MM/AAAA)"
            label="Data de término"
            mask="datetime"
            maskOptions={{
              format: 'DD/MM/YYYY',
            }}
          />
          <ButtonSalvarLimpar
            isOK
            isEdit
            cancelLabel="Cancelar"
            onPressClear={onClose}
            onPressSave={() => handleSaveUserEdit()}
          />
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  modalContent: {
    width: '40%',
    backgroundColor: '#FFF',
    borderRadius: 10,
    padding: 20,
    alignItems: 'center',
  },
});

export default ModalDate;
